<script>
import { getCards, addCard, deleteCard } from "@/api/subscribers";
import { getGuestCards } from "@/api/guests";
import validate from "validate.js";
var constraints = {
  firstSixDigitsLength: {
    length: { is: 6 }
  },
  isNumber: {
    numericality: {
      onlyInteger: true
    }
  }
};
export default {
  name: "cards-list",
  props: ["item"],
  data() {
    return {
      items: [],
      selected: [],
      options: [
        { value: "visa", text: "Visa" },
        { value: "mastercard", text: "Mastercard" },
        { value: "amex", text: "Amex" }
      ],
      form: {
        card_brand: "visa",
        first_six_digits: "",
        last_four_digits: ""
      },
      firstSixDigitsRules: [
        v => !!v || "First 6 digits card number is required",
        v =>
          !validate({ firstSixDigitsLength: v }, constraints) ||
          "Must be 6 digtis",
        v => !validate({ isNumber: v }, constraints) || "Must be a number"
      ],
      headers: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "id"
        },
        { text: "", value: "card_brand" },
        { text: "", value: "first_six_digits" },
        { text: "", value: "last_four_digits" }
      ],
      guest: "guest"
    };
  },
  mounted() {
    // console.log("Card list mounted...");
    // console.log(this.item.id);
    this.guest = localStorage.getItem("guest");
    setTimeout(() => this.getCards(), 1000);
  },
  methods: {
    async getCards() {
      if (this.guest == "subscriber") {
        this.items = this.item.id ? await getCards(this.item.id) : [];
      }
      if (this.guest == "guest") {
        this.items = this.item.id ? await getGuestCards(this.item.id) : [];
      }
    },
    async addCard() {
      const payload = JSON.parse(JSON.stringify(this.form));
      const response = await addCard(this.item.id, payload);
      if (response) {
        this.$bvToast.toast(`Credit card added`, {
          title: "Credit Card",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "success"
        });
        this.items = await getCards(this.item.id);
      } else {
        this.$bvToast.toast(`Error in adding a credit card`, {
          title: "Credit Card",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "danger"
        });
      }
    },
    async removeItem(id) {
      const response = await deleteCard(this.item.id, id);
      if (response) {
        this.$bvToast.toast(`Credit card deleted`, {
          title: "Credit Card",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "success"
        });
        this.items = await getCards(this.item.id);
      } else {
        this.$bvToast.toast(`Error in deleting credit card`, {
          title: "Credit Card",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "danger"
        });
      }
    }
  }
};
</script>

<template>
  <v-row class="p-1">
    <v-col cols="12">
      <v-card class="mx-auto rounded-lg" outlined>
        <v-card-title>
          <span class="title font-weight-bold">
            CARDS
          </span>
        </v-card-title>
        <div v-if="guest == 'subscriber'">
          <b-input-group class="mt-3 pl-5 pr-5">
            <b-form-select
              v-model="form.card_brand"
              :options="options"
            ></b-form-select>
            <div class="invalid-feedback">Country cannot be blank.</div>
            <b-form-input
              v-model="form.first_six_digits"
              placeholder="Enter First 6 Digits"
              maxlength="6"
            ></b-form-input>
            <b-form-input
              v-model="form.last_four_digits"
              placeholder="Enter Last 4 Digits"
              maxlength="4"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="primary" @click="addCard">Add</b-button>
            </b-input-group-append>
          </b-input-group>

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            item-key="id"
            :sort-by="['card_brand']"
            class="mt-5 mb-5"
            dense
            :hide-default-header="false"
            :hide-default-footer="true"
          >
            <template v-slot:item.id="{ item }">
              <v-icon left @click="removeItem(item.id)"> mdi-delete </v-icon>
            </template>

            <template v-slot:item.first_six_digits="{ item }">
              XXXXXX
            </template>
          </v-data-table>
        </div>
        <v-simple-table v-if="guest == 'guest'">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Fist six digits
                </th>
                <th class="text-left">
                  Last four digits
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="index">
                <td>XXXXXX</td>
                <td>{{ item.last_four_digits }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-col>
  </v-row>
</template>
